import { cn } from './ui';
import { dayKeyOf, formatDayNumber, formatWeekday } from '../lib/format';

interface DayStripProps {
  days: Date[];
  selectedKey: string;
  timeZone: string;
  onSelect: (day: Date) => void;
  /** Сколько занятий в каждом дне — точка под числом. */
  counts: Record<string, number>;
}

/**
 * Горизонтальная лента дней. На телефоне это основной способ навигации
 * по расписанию: месячная сетка на маленьком экране нечитаема.
 */
export function DayStrip({
  days,
  selectedKey,
  timeZone,
  onSelect,
  counts,
}: DayStripProps): React.JSX.Element {
  const todayKey = dayKeyOf(new Date().toISOString(), timeZone);

  return (
    <div className="snap-row no-scrollbar -mx-4 flex gap-2 overflow-x-auto px-4 pb-1">
      {days.map((day) => {
        const iso = day.toISOString();
        const key = dayKeyOf(iso, timeZone);
        const isSelected = key === selectedKey;
        const count = counts[key] ?? 0;

        return (
          <button
            key={key}
            type="button"
            onClick={() => onSelect(day)}
            className={cn(
              'snap-item flex min-h-16 w-14 shrink-0 flex-col items-center justify-center rounded-xl border text-sm transition-colors',
              isSelected
                ? 'border-brand-600 bg-brand-600 text-white'
                : 'border-line bg-surface text-ink hover:bg-slate-50',
            )}
            aria-pressed={isSelected}
          >
            <span className={cn('text-[11px] uppercase', isSelected ? 'text-brand-100' : 'text-muted')}>
              {formatWeekday(iso, timeZone)}
            </span>
            <span className="text-base font-semibold">{formatDayNumber(iso, timeZone)}</span>
            <span
              className={cn(
                'mt-0.5 size-1.5 rounded-full',
                count === 0
                  ? 'bg-transparent'
                  : isSelected
                    ? 'bg-white'
                    : key === todayKey
                      ? 'bg-brand-600'
                      : 'bg-slate-300',
              )}
              aria-hidden
            />
          </button>
        );
      })}
    </div>
  );
}
